// Wither override (MOB-6 boss, M20.1). PURE (ENG-1).
//
// A three-headed flying boss. On spawn it charges up for WITHER.SUMMON_TICKS —
// hovering in place and shrugging off all damage (the host's `invulnerable` seam
// reads `data.summonTicks`) — then bursts into a skull barrage. It fires faster in
// phase 2 (below half health). Movement/fire reuse the flying-mob primitives.
import { FLYING, WITHER } from '../../config';
import type { MobDef } from '../../registry/schemas';
import type { Entity, MobContext } from '../entity';
import { difficultyScale } from '../archetypes/shared';
import { fireFireballAt } from '../projectiles/fireball';
import { witherPhase, witherSkullInterval } from '../../game/wither';

export function wither(e: Entity, def: MobDef, ctx: MobContext): void {
  const { frame, sys } = ctx;

  // Charge-up window: hover, invulnerable, then arm for the fight.
  if (e.data.witherArmed === undefined) { e.data.summonTicks = WITHER.SUMMON_TICKS; e.data.witherArmed = 1; }
  if ((e.data.summonTicks ?? 0) > 0) {
    e.data.summonTicks = (e.data.summonTicks ?? 0) - 1;
    e.wishX = 0; e.wishY = 0; e.wishZ = 0; // hover in place while charging
    e.targetIdx = -1;
    return;
  }

  const phase = witherPhase(e.health, e.maxHealth, 0);
  const scale = difficultyScale(frame.difficulty);
  const target = scale > 0 ? sys.nearestPlayer(frame, e.x, e.y, e.z, def.followRange) : null;
  if (!target) { e.wishX = 0; e.wishY = 0; e.wishZ = 0; e.targetIdx = -1; return; }

  const pl = frame.players[target.idx]!;
  e.targetIdx = target.idx;
  const dx = pl.x - e.x, dz = pl.z - e.z;
  const d = Math.hypot(dx, dz) || 1;
  e.yaw = Math.atan2(-dx, -dz);
  // Close in slowly and stay a few blocks overhead.
  e.wishX = (dx / d) * FLYING.MAX_SPEED * 0.5;
  e.wishZ = (dz / d) * FLYING.MAX_SPEED * 0.5;
  e.wishY = Math.sign(pl.y + 4 - e.y) * FLYING.MAX_SPEED * 0.5;

  // Skull barrage on the phase cadence.
  e.data.fireCd = (e.data.fireCd ?? 0) - 1;
  if (e.data.fireCd <= 0) {
    fireFireballAt(sys, e, pl.x, pl.y + pl.eyeY, pl.z);
    e.data.fireCd = witherSkullInterval(phase);
  }
}
